exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "k-upload form.dropzone {\n  border-radius: 10px;\n  border-style: dashed;\n}\n\nk-upload .button-bar,\nk-upload .results {\n  margin-top: 10px;\n}\n\nk-upload .button-bar button {\n  margin-left: 5px;\n  margin-right: 5px;\n}\n\nk-upload .dropzone .dz-preview .dz-details .dz-size {\n  margin-bottom: 3rem;\n}\n\nk-upload .dz-error-mark {\n  background: red;\n}\n\nk-upload .results li.success {\n  color: darkgreen;\n}\n\nk-upload .results li.error {\n  color: red;\n}\n", ""]);

// exports
